<template>
    <div class="all_dy">
        全部订阅
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang="less" scoped>

</style>